export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_fluffy-lab/artifacts/y6v21011_Logo%20Amyu%20final%20%281%29.png";

export const TIRAMISUS = [
  {
    id: "tira-kinder",
    name: "Tiramisu Kinder Bueno",
    tagline: "Une véritable crème mascarpone onctueuse, du chocolat fondant et de généreux morceaux de Kinder Bueno.",
    price: 3.5,
    bg: "bg-amyu-biscuit",
    image:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_fluffy-lab/artifacts/2siph4es_94974874-D16A-4E21-B8EB-D69FE2F1F832.jpeg",
    badge: "Best-seller",
  },
  {
    id: "tira-caramel-speculoos",
    name: "Tiramisu Caramel Beurre Salé Spéculoos",
    tagline: "Une véritable crème mascarpone fondante, un caramel gourmand et de généreux éclats de spéculoos.",
    price: 3,
    bg: "bg-amyu-vanilla",
    image:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_fluffy-lab/artifacts/6cgb47yc_1B375CAB-8CAE-41F2-A857-B520D954A3CD.jpeg",
    badge: null,
  },
  {
    id: "tira-choco-noisette",
    name: "Tiramisu Choco Noisette",
    tagline: "Une véritable crème mascarpone chocolatée, de délicats éclats de noisettes et une gourmandise irrésistible.",
    price: 3,
    bg: "bg-amyu-biscuit",
    image:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_fluffy-lab/artifacts/4ii4i2xp_7BEDCC3D-E438-4A6E-BC4A-C1014618F1D6.jpeg",
    badge: "Nouveau",
  },
  {
    id: "tira-fraise-pistache",
    name: "Tiramisu Fraise Pistache",
    tagline: "Une véritable crème mascarpone onctueuse, des fraises gourmandes et des éclats de pistache croquants.",
    price: 3,
    bg: "bg-amyu-pink",
    image:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_fluffy-lab/artifacts/3cfribj3_37204BA7-8974-48DF-BDB6-25F406973FC8.jpeg",
    badge: "Saison",
  },
  {
    id: "tira-mangue",
    name: "Tiramisu Mangue Passion",
    tagline: "Une véritable crème mascarpone légère, une purée de mangue juteuse et une touche exotique de passion.",
    price: 3,
    bg: "bg-amyu-mango",
    image:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_fluffy-lab/artifacts/7a7c8atf_C98B7205-937E-4FD8-936F-D4298BE55DD8.jpeg",
    badge: null,
  },
];

export const DRINKS = [
  {
    id: "cloud-lime",
    name: "Cloud Lime",
    tagline: "Citron vert, mousse aérienne",
    color: "from-[#cce6c4] to-[#fff5d6]",
    image:
      "https://images.unsplash.com/photo-1556679343-c7306c1976bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    id: "pink-cloud",
    name: "Pink Cloud",
    tagline: "Fraise, framboise, foam rose",
    color: "from-[#ffd1dc] to-[#ffe6ec]",
    image:
      "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    id: "sunny-cloud",
    name: "Sunny Cloud",
    tagline: "Mangue, passion, soleil en verre",
    color: "from-[#ffd8a8] to-[#fff5d6]",
    image:
      "https://images.unsplash.com/photo-1497534446932-c925b458314e?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    id: "matcha-fraise",
    name: "Matcha Fraise",
    tagline: "Matcha cérémonie, fraises bio",
    color: "from-[#cce6c4] to-[#ffd1dc]",
    image:
      "https://images.unsplash.com/photo-1717398804998-ad2d48822518?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    id: "matcha-mangue",
    name: "Matcha Mangue",
    tagline: "Matcha doux, mangue veloutée",
    color: "from-[#cce6c4] to-[#ffd8a8]",
    image:
      "https://images.unsplash.com/photo-1749280447307-31a68eb38673?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    id: "foam-coffee",
    name: "Foam Coffee",
    tagline: "Café, mousse vanille nuage",
    color: "from-[#f5e5d3] to-[#fff5d6]",
    image:
      "https://images.unsplash.com/photo-1572442388796-11668a67e53d?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
];

export const GALLERY = [
  "https://customer-assets.emergentagent.com/job_fluffy-lab/artifacts/pf9jbyjs_5430F292-B44F-474B-AB9B-84E5DF46FA33.png",
  "https://customer-assets.emergentagent.com/job_fluffy-lab/artifacts/vqmlhk0a_4D5C8FA3-A4F0-44B0-9A84-2EB7C6F3A8BA.png",
  "https://customer-assets.emergentagent.com/job_fluffy-lab/artifacts/vbybpv6o_8C6CAE52-926D-497B-A60F-FCCAECB66421.png",
  "https://customer-assets.emergentagent.com/job_fluffy-lab/artifacts/vffcwy4n_D5B4B428-06F6-4E85-924E-71D2E7622334.png",
  "https://customer-assets.emergentagent.com/job_fluffy-lab/artifacts/msjmjt9w_B4D4E065-7070-4133-9A0D-21378EA4F8B8.png",
  "https://customer-assets.emergentagent.com/job_fluffy-lab/artifacts/e5xkw0q1_F5A20786-B916-4609-8E6E-B3494B9378D6.png",
  "https://customer-assets.emergentagent.com/job_fluffy-lab/artifacts/axjl26di_F3FD638E-ADAB-4594-92C3-48CC985C3519.png",
  "https://customer-assets.emergentagent.com/job_fluffy-lab/artifacts/5vhbxsqc_413AFB11-25FE-4061-83EA-61F353D6EB3C.png",
];

export const FAQ_ITEMS = [
  {
    q: "Comment commander ?",
    a: "Rends-toi dans la section « Commander » et remplis le formulaire avec tes envies. On te confirme ta commande par email sous 24h.",
  },
  {
    q: "Comment récupérer ma commande ?",
    a: "Click & Collect au point de rendez-vous Amyu. La date et l'heure te sont communiquées dans notre email de confirmation.",
  },
  {
    q: "Comment fonctionnent les précommandes ?",
    a: "Les précommandes ouvrent en exclusivité pour les membres du Cloud Club, 48h avant tout le monde. Inscris-toi pour ne rien manquer !",
  },
  {
    q: "Combien de temps se conservent les produits ?",
    a: "Tiramisus & desserts : 48h au frais. Cookies : 5 jours dans une boîte hermétique. Boissons cloud : à déguster immédiatement.",
  },
  {
    q: "Avez-vous des options sans gluten / végan ?",
    a: "Oui, on développe régulièrement des alternatives ! Surveille la section Amyu Lab et inscris-toi au Cloud Club pour les annonces.",
  },
];
